import React, { useState, useEffect, useRef } from 'react';
// import { tabs } from "../../../../pages/Casino/CasinoGames.utils";
// import { useNavigate } from "react-router-dom";
import forward from '../../assets/images/home/forward.svg';
import backward from '../../assets/images/home/backward.svg';
// import { JwtToken } from "../../../../../utils/commonUtils";
import './GamesContainer.css';
import { useSelector } from 'react-redux';
import { RootState } from '../../models/RootState';
import { useHistory } from 'react-router';
import { Dialog } from '@material-ui/core';

interface GamesContainerProps {
  title: string;
  gameList: any[];
  url?: string;
}

const GamesContainer: React.FC<GamesContainerProps> = ({
  title,
  gameList,
  url,
}) => {
  const loggedIn = useSelector((state: RootState) => state.auth.loggedIn);
  const langData = useSelector((state: RootState) => state.common.langData);
  const [dialogShow, setDialogShow] = useState<boolean>(false);
  // const [selectedCategory, setSelectedCategory] = useState(tabs);
  const [gamesDisplay, setGamesDisplay] = useState([]);
  const [activeCategory, setActiveCategory] = useState<string | null>(
    'Originals'
  );
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const history = useHistory();

  // const navigate = useNavigate();
  const gamesContainerRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   const defaultCategory = selectedCategory.find(
  //     (item) => item.title === activeCategory
  //   );
  //   if (defaultCategory) {
  //     handleFilteredGames(defaultCategory.filterParams);
  //   }
  // }, [games, activeCategory, selectedCategory]);

  // const handleFilteredGames = (tabs) => {
  //   const filteredGames = games.filter((game) =>
  //     tabs.some(
  //       (param) =>
  //         param.toLowerCase() === game.providerName.toLowerCase() ||
  //         param.toLowerCase() === game.subProviderName.toLowerCase()
  //     )
  //   );
  //   setGamesDisplay(filteredGames);
  // };

  // const handleCategoryClick = (item) => {
  //   handleFilteredGames(item.filterParams);
  //   setActiveCategory(item.title);
  // };

  // const handleGameClick = async (
  //   gameId: string,
  //   gameName: string,
  //   gameCode: string,
  //   subProvider: string,
  //   provider?: string
  // ) => {
  //   if (loggedIn) {
  //     const loggedInUserStatus = getFieldFromToken(JwtToken.STATUS);
  //     if (loggedInUserStatus === 0 || loggedInUserStatus === 3) {
  //       navigate(`/home`);
  //     } else {
  //       navigate(
  //         `/dc/gamev1.1/${gameName?.toLowerCase().replace(/\s+/g, "-")}-${btoa(
  //           gameId?.toString()
  //         )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
  //       );
  //     }
  //   } else {
  //     setDialogShow(true);
  //   }
  // };

  const scrollContainer = (direction: 'forward' | 'backward') => {
    if (gamesContainerRef.current) {
      const scrollAmount = direction === 'forward' ? 200 : -200;
      gamesContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const getRoyalGamingUrl = async (
    gameId: string,
    gameName: string,
    gameCode: string,
    provider: string,
    subProvider: string
  ) => {
    if (loggedIn) {
      if (provider === 'Indian Casino') {
        history.push(`/casino/indian/${gameCode}`);
      } else {
        history.push(
          `/dc/gamev1.1/${gameName.toLowerCase().replace(/\s+/g, '-')}-${btoa(
            gameId.toString()
          )}-${btoa(gameCode)}-${btoa(provider)}-${btoa(subProvider)}`
        );
      }
    }
  };

  const defaultFavourites = [
    {
      gameId: '525001',
      category: 'Crash Games',
      gameCode: 'CRASH88-CAV101-VR',
      gameName: 'AVIATORX',
      urlThumb: 'https://cdn.dreamdelhi.com/monk88/aviatorx.webp',
      urlBackground: '',
      trendingThumbnail: '',
      providerName: 'CRASH88',
      subProviderName: 'CRASH88 Gaming',
      status: null,
      enabled: true,
    },
  ];

  const handleGameClick = (game) => {
    getRoyalGamingUrl(
      game.gameId,
      game.gameName,
      game.gameCode,
      game.providerName,
      game.subProviderName
    );
  };

  const handlePlusBtn = () => {
    setDialogOpen(true);
  };

  return (
    <div className='games-ctn'>
      <div className="games-container">
        <div className="games-container-card">
          <div className="games-header">
            <div className="categories-container">
              <div className="category-item">{title}</div>
              <div className="gradient-line"></div>
            </div>
            {/* <div className="scroll-buttons">
            <button onClick={() => scrollContainer('backward')}>
              <img src={backward} alt="backward" />
            </button>
            <button onClick={() => scrollContainer('forward')}>
              <img src={forward} alt="forward" />
            </button>
          </div> */}
            <div className="viewall-casino" onClick={() => history.push(url)}>
              {langData?.['view_all']}
            </div>
          </div>
          <div className="games-display">
            <div ref={gamesContainerRef} className="games-grid no-scrollbar">
              {gameList?.length > 0 ? (
                gameList?.map((card, index) => (
                  <div
                    onClick={() => handleGameClick(card)}
                    key={card.gameId + index}
                    className="game-card"
                  >
                    <img
                      src={
                        card?.trendingThumbnail
                          ? card?.trendingThumbnail
                          : card?.urlThumb
                      }
                      alt={card.gameName}
                    />
                  </div>
                ))
              ) : (
                <>
                  {defaultFavourites?.map((card, index) => (
                    <div
                      onClick={() => handleGameClick(card)}
                      key={card.gameId + index}
                      className="game-card"
                    >
                      <img
                        src={
                          card?.trendingThumbnail
                            ? card?.trendingThumbnail
                            : card?.urlThumb
                        }
                        alt={card.gameName}
                      />
                    </div>
                  ))}
                </>
              )}
              <div onClick={handlePlusBtn} className="game-card">
                <button className="plus-btn">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        aria-labelledby="form-dialog-title"
        className="dialog-divison"
      >
        <div className="dialog-div-body">
          <div className="dialog-title">{langData?.['game_info']}</div>
          <div className="dialog-body">
            <div className="dialog-ex">
              {langData?.['add_to_favourites']}{' '}
              <span
                className="click-here"
                onClick={() => history.push('/casino')}
              >
                {langData?.['click_here_to_visit']}
              </span>
            </div>
          </div>
          <div className="dialog-continue">
            <div
              className="custom-btn-close"
              onClick={() => {
                setDialogOpen(false);
              }}
            >
              {langData?.['close']}
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default GamesContainer;
